import { ClassName } from '@/blocks/components/types';
import classNames from 'classnames';
import Link from 'next/link';
import React, { PropsWithChildren } from 'react';

export function LinkEmail(props: PropsWithChildren<{ className?: ClassName; email: string }>) {
  return (
    <Link href={`mailto:${props.email}`} className={classNames(props.className)}>
      {props.children ? props.children : props.email}
    </Link>
  );
}
